import * as React from 'react';
import Button from '@mui/material/Button';
import EmailIcon from '@mui/icons-material/Email';

export default function EmailButton() {
  const sendEmail = () => {
    window.open(`mailto:salesjhb@autoboys.com?subject=Parts%20Enquiry&body=Hi%20Autoboys%20Sales%20Team%2C%0A%0AI%20want%20to%20enquire%20about%20the%20following%20parts%3A%0A${JSON.parse(localStorage.getItem("wishlist"))?.join("%0A") ?? ""}%0A%0AThanks%2C%0AYour%20Customer`, '_blank');
    return false;
  };

  return (
      <Button style={{position:"fixed",bottom:0,left:0,background:"lightgrey",borderRadius:"50%",minWidth:"50px",minHeight:"50px",margin:"5px"}} onClick={sendEmail}><EmailIcon fontSize="large"/></Button>
  );
}